import React, { Component, Fragment } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  MuiThemeProvider,
} from "@material-ui/core";

export class Step3 extends Component {
  first = (e) => {
    setTimeout(() => {
      this.props.firstStep();
    }, 4000);
  };
  render() {
    return (
      <MuiThemeProvider>
        <AppBar style={{ background: "#77E976" }} position="sticky">
          <Toolbar title="Enter Personal Information">
            <Typography color="inherit" variant="title">
              Confirm Details
            </Typography>
          </Toolbar>
        </AppBar>
        <br />
        <Typography variant="title">Thank you for your submission!</Typography>
        <br />
        <Typography>You will get an email with further instructions</Typography>
        <button
          className="btn btn-lg btn-primary"
          type="button"
          onClick={this.first}
        >
          Next
        </button>
      </MuiThemeProvider>
    );
  }
}

export default Step3;
